import filterArrayObObjsByKeys from "../../../../utils/filters/filterArrayObObjsByKeys";
import dtoToViewFilterArray from "../../../../utils/formSupport/dtoToViewFilterArray";
const filterPersonAddresses = (personAddresses) => {
  const filteredPersonAddresses = personAddresses.filter(
    (persAdd) =>
      persAdd.id ||
      persAdd.address ||
      persAdd.postalCode ||
      persAdd.latitude ||
      persAdd.longitude ||
      persAdd.province?.id ||
      persAdd.addressTypeEnum ||
      persAdd.city?.id ||
      persAdd.eci_personAddressContactInfos.filter(
        (perAddCon) => perAddCon.id || perAddCon.value || perAddCon.contactInfoTypeEnum
      ).length > 0
  );

  const newPersonAddresses = filteredPersonAddresses.map((each) => ({
    ...each,
    eci_personAddressContactInfos: filterArrayObObjsByKeys(each.eci_personAddressContactInfos, [
      "contactInfoTypeEnum",
      "id",
      "value",
    ]),
  }));
  return newPersonAddresses;
};
const PersonnelInformationFormSupport = () => {
  let personnelInformationView = {
    id: null,
    firstName: null,
    lastName: null,
    nationalCode: null,
    cellphone: null,
    workStartDate: null,
    readyToStartWorkDate: null,
    salaryExpectation: null,
    financialGuaranteeValue: null,
    financialGuaranteeTypeEnum: null,
    guarantorName: null,
    preferredTimeZone: "+3:30",
    preferredLanguage: "persian",
    preferredCalendar: "pe",
    personnelSalaryDifferenceValue: null,
    personnelSalaryDifferenceToDate: null,
    hasRelativeOrFriendInOrganization: null,
    relativeOrFriendNameInOrganization: null,
    isReadyForBusinessTrip: null,
    isWillingToProvideFinancialGuarantee: null,
    companyFamiliarityMethodsEnum: null,
    companyFamiliarityOtherMethod: null,
    referrerName: null,
    state: null,
    stateEnglishName: null,
    documentSubmissionSchedules: null,
    startWorkSchedules: null,
    businessUnit: null,
    mainOffice: null,
    otherOffices: null,
    mainOrganizationalTitle: null,
    otherInterestedInOrganizationalTitles: null,
    corporateChart: null,
    processVersion: null,
    ci_personnel: [
      {
        id: null,
        personnelCode: null,
        internalPhoneNumber: null,
        // financialGuaranteeValue: null,
        // financialGuaranteeTypeEnum: null,
        // guarantorName: null,
        insuranceCode: null,
        insuranceDate: null,
        isActive: true,
        ci_personnelFiles: null,
        ci_personnelContracts: null,
        editingFieldsOfMainObject: null,
        relatedMainObject: null,
        nationalityEnum: "ایرانی",
        ci_personnelBankAccounts: [
          {
            id: null,
            bankAccountNumber: null,
            ibanCode: null,
            isActive: true,
            isDefault: null,
            isForThirdParty: false,
            bankAccountOwnerFullName: null,
            relationWithPersonnel: null,
            otherIndividualIntroductionDocument: null,
            tempOtherIndividualIntroductionDocument: {
              uploadedFile: null,
              uploadedFileReader: null,
              downloadedFile: null,
              successfullyUploadedFileId: null,
              hasChanged: null,
            },
            bankBranch: null,
            editingFieldsOfMainObject: null,
            relatedMainObject: null,
          },
        ],
      },
    ],
    eci_personnelInformation: {
      id: null,
      jobApply: null,
      editingFieldsOfMainObject: null,
      relatedMainObject: null,
      eci_competencies: [
        {
          id: null,
          levelOfProficiency: null,
          competencyName: null,
        },
      ],
      eci_foreignLanguages: [
        {
          id: null,
          languageName: null,
          listening: null,
          writing: null,
          reading: null,
          speaking: null,
        },
      ],
      eci_person: {
        id: null,
        fatherName: null,
        certifNumber: null,
        birthplace: null,
        certifSerialNumber: null,
        certifIssuanceDate: null,
        maritalStatusEnum: null,
        militaryStatusEnum: null,
        healthProblems: null,
        hasClassOneDriversLicense: null,
        hasClassTwoDriversLicense: null,
        hasBikeLicense: null,
        birthCertificateIssuingPlace: null,
        bloodTypeEnum: null,
        nationalCode: null,
        firstName: null,
        lastName: null,
        birthDate: null,
        genderEnum: null,
        cellphone: null,
        email: null,
        nationalityEnum: "ایرانی",
        isActive: null,
        eci_personContactInfos: [
          {
            id: null,
            value: null,
            contactInfoTypeEnum: null,
            editingFieldsOfMainObject: null,
            relatedMainObject: null,
          },
        ],
        eci_personAddresses: [
          {
            id: null,
            address: null,
            postalCode: null,
            countryEnum: "ایران",
            latitude: null,
            longitude: null,
            addressTypeEnum: null,
            province: null,
            eci_personAddressContactInfos: [
              {
                id: null,
                value: null,
              },
            ],
            city: null,
            editingFieldsOfMainObject: null,
            relatedMainObject: null,
            eci_person: { nationalityEnum: "ایرانی" },
          },
        ],
        personTags: null,
        personTitle: null,
        editingFieldsOfMainObject: null,
        relatedMainObject: null,
      },

      eci_educationalBackgrounds: [
        {
          id: null,
          startDate: null,
          finishDate: null,
          thesisAim: null,
          favoriteUnits: null,
          gradePointAverage: null,
          otherInstitute: null,
          degreeLevelEnum: null,
          academicOrientation: null,
          major: null,
          educationalInstitute: { id: null },
          editingFieldsOfMainObject: null,
          relatedMainObject: null,
          currentlyStudying: null,
          faculty: null,
        },
      ],
      eci_recommenders: [
        {
          id: null,
          fullName: null,
          age: null,
          cellphone: null,
          job: null,
          workplace: null,
          relation: null,
          editingFieldsOfMainObject: null,
          relatedMainObject: null,
        },
      ],
      eci_personnelInformationFiles: [
        {
          id: null,
          personnelFileTypeEnum: null,
          isActive: null,
          eci_personnelInformation: null,
          fileStorage: null,
          editingFieldsOfMainObject: null,
          relatedMainObject: null,
          tempFileStorage: {
            uploadedFile: null,
            uploadedFileReader: null,
            downloadedFile: null,
            successfullyUploadedFileId: null,
            hasChanged: null,
          },
        },
      ],
      eci_courses: [
        {
          id: null,
          title: null,
          startDate: null,
          duration: null,
          hasDiploma: null,
          otherInstitute: null,
          educationalInstitute: null,
          editingFieldsOfMainObject: null,
          relatedMainObject: null,
        },
      ],
      eci_familyMembers: [
        {
          id: null,
          fullName: null,
          familyRelationEnum: null,
          age: null,
          job: null,
          cellphone: null,
          workplace: null,
          isDead: false,
          editingFieldsOfMainObject: null,
          relatedMainObject: null,
        },
      ],
      eci_workExperiences: [
        {
          id: null,
          employer: null,
          post: null,
          directManagerName: null,
          directManagerCellphone: null,
          salary: null,
          resigningReason: null,
          startDate: null,
          finishDate: null,
          editingFieldsOfMainObject: null,
          relatedMainObject: null,
        },
      ],
      eci_policeClearanceCertificates: [
        {
          id: null,
          policeClearanceCertificateDate: null,
          policeClearanceCertificateCode: null,
          fileStorage: null,
          tempFileStorage: {
            uploadedFile: null,
            uploadedFileReader: null,
            downloadedFile: null,
            successfullyUploadedFileId: null,
            hasChanged: null,
          },
          editingFieldsOfMainObject: null,
          relatedMainObject: null,
        },
      ],
    },
    tempHasNoCompetency: false,
    tempHasNoWorkExp: false,
    tempKnowsNoForeignLan: false,
    tempNoCoursePassed: false,
    tempNotEducatedAtAll: false,
  };
  let personnelInformationDto = {
    id: null,
    firstName: null,
    lastName: null,
    nationalCode: null,
    cellphone: null,
    workStartDate: null,
    readyToStartWorkDate: null,
    salaryExpectation: null,
    financialGuaranteeValue: null,
    financialGuaranteeTypeEnum: null,
    guarantorName: null,
    preferredTimeZone: "+3:30",
    preferredLanguage: "persian",
    preferredCalendar: "pe",
    personnelSalaryDifferenceValue: null,
    personnelSalaryDifferenceToDate: null,
    hasRelativeOrFriendInOrganization: null,
    isReadyForBusinessTrip: null,
    isWillingToProvideFinancialGuarantee: null,
    companyFamiliarityMethodsEnum: null,
    companyFamiliarityOtherMethod: null,
    referrerName: null,
    relativeOrFriendNameInOrganization: null,
    state: null,
    stateEnglishName: null,
    documentSubmissionSchedules: null,
    startWorkSchedules: null,
    businessUnit: null,
    mainOffice: null,
    otherOffices: null,
    mainOrganizationalTitle: null,
    otherInterestedInOrganizationalTitles: null,
    corporateChart: null,
    processVersion: null,
    ci_personnel: [
      {
        id: null,
        personnelCode: null,
        internalPhoneNumber: null,
        // financialGuaranteeValue: null,
        // financialGuaranteeTypeEnum: null,
        // guarantorName: null,
        insuranceCode: null,
        insuranceDate: null,
        isActive: true,
        ci_personnelFiles: null,
        ci_personnelContracts: null,
        editingFieldsOfMainObject: null,
        relatedMainObject: null,
        nationalityEnum: "ایرانی",
        ci_personnelBankAccounts: [
          {
            id: null,
            bankAccountNumber: null,
            ibanCode: null,
            isActive: null,
            isDefault: null,
            isForThirdParty: false,
            bankAccountOwnerFullName: null,
            relationWithPersonnel: null,
            otherIndividualIntroductionDocument: null,
            bankBranch: null,
            editingFieldsOfMainObject: null,
            relatedMainObject: null,
          },
        ],
      },
    ],
    eci_personnelInformation: {
      id: null,
      jobApply: null,
      editingFieldsOfMainObject: null,
      relatedMainObject: null,
      eci_person: {
        id: null,
        fatherName: null,
        certifNumber: null,
        birthplace: null,
        certifSerialNumber: null,
        certifIssuanceDate: null,
        maritalStatusEnum: null,
        militaryStatusEnum: null,
        healthProblems: null,
        hasClassOneDriversLicense: null,
        hasClassTwoDriversLicense: null,
        hasBikeLicense: null,
        birthCertificateIssuingPlace: null,
        bloodTypeEnum: null,
        nationalCode: null,
        firstName: null,
        lastName: null,
        birthDate: null,
        genderEnum: null,
        cellphone: null,
        email: null,
        nationalityEnum: "ایرانی",
        isActive: null,
        eci_personContactInfos: [
          {
            id: null,
            value: null,
            contactInfoTypeEnum: null,
            editingFieldsOfMainObject: null,
            relatedMainObject: null,
          },
        ],
        eci_personAddresses: [
          {
            id: null,
            address: null,
            postalCode: null,
            countryEnum: "ایران",
            latitude: null,
            longitude: null,
            addressTypeEnum: null,
            province: null,
            eci_personAddressContactInfos: [
              {
                id: null,
                value: null,
              },
            ],
            city: null,
            editingFieldsOfMainObject: null,
            relatedMainObject: null,
            eci_person: { nationalityEnum: "ایرانی" },
          },
        ],
        personTags: null,
        personTitle: null,
        editingFieldsOfMainObject: null,
        relatedMainObject: null,
      },

      eci_competencies: [
        {
          id: null,
          levelOfProficiency: null,
          competencyName: null,
        },
      ],
      eci_foreignLanguages: [
        {
          id: null,
          languageName: null,
          listening: null,
          writing: null,
          reading: null,
          speaking: null,
        },
      ],
      eci_educationalBackgrounds: [
        {
          id: null,
          startDate: null,
          finishDate: null,
          thesisAim: null,
          favoriteUnits: null,
          gradePointAverage: null,
          otherInstitute: null,
          degreeLevelEnum: null,
          academicOrientation: null,
          major: null,
          educationalInstitute: { id: null },
          editingFieldsOfMainObject: null,
          relatedMainObject: null,
          currentlyStudying: null,
          faculty: null,
        },
      ],
      eci_recommenders: [
        {
          id: null,
          fullName: null,
          age: null,
          cellphone: null,
          job: null,
          workplace: null,
          relation: null,
          editingFieldsOfMainObject: null,
          relatedMainObject: null,
        },
      ],
      eci_personnelInformationFiles: [
        {
          id: null,
          personnelFileTypeEnum: null,
          isActive: null,
          eci_personnelInformation: null,
          fileStorage: null,
          editingFieldsOfMainObject: null,
          relatedMainObject: null,
        },
      ],
      eci_courses: [
        {
          id: null,
          title: null,
          startDate: null,
          duration: null,
          hasDiploma: null,
          otherInstitute: null,
          educationalInstitute: null,
          editingFieldsOfMainObject: null,
          relatedMainObject: null,
        },
      ],
      eci_familyMembers: [
        {
          id: null,
          fullName: null,
          familyRelationEnum: null,
          age: null,
          job: null,
          cellphone: null,
          workplace: null,
          isDead: false,
          editingFieldsOfMainObject: null,
          relatedMainObject: null,
        },
      ],
      eci_workExperiences: [
        {
          id: null,
          employer: null,
          post: null,
          directManagerName: null,
          directManagerCellphone: null,
          salary: null,
          resigningReason: null,
          startDate: null,
          finishDate: null,
          editingFieldsOfMainObject: null,
          relatedMainObject: null,
        },
      ],
      eci_policeClearanceCertificates: [
        {
          id: null,
          policeClearanceCertificateDate: null,
          policeClearanceCertificateCode: null,
          fileStorage: null,
          editingFieldsOfMainObject: null,
          relatedMainObject: null,
        },
      ],
    },
  };
  let personnelInformationFromValidity = {
    firstName: { isValid: true, msg: "" },
    lastName: { isValid: true, msg: "" },
    nationalCode: { isValid: true, msg: "" },
    cellphone: { isValid: true, msg: "" },
    workStartDate: { isValid: true, msg: "" },
    readyToStartWorkDate: { isValid: true, msg: "" },
    salaryExpectation: { isValid: true, msg: "" },
    financialGuaranteeValue: { isValid: true, msg: "" },
    financialGuaranteeTypeEnum: { isValid: true, msg: "" },
    guarantorName: { isValid: true, msg: "" },
    preferredTimeZone: { isValid: true, msg: "" },
    preferredLanguage: { isValid: true, msg: "" },
    preferredCalendar: { isValid: true, msg: "" },
    personnelSalaryDifferenceValue: { isValid: true, msg: "" },
    personnelSalaryDifferenceToDate: { isValid: true, msg: "" },
    state: { isValid: true, msg: "" },
    stateEnglishName: { isValid: true, msg: "" },
    documentSubmissionSchedules: { isValid: true, msg: "" },
    hasRelativeOrFriendInOrganization: { isValid: true, msg: "" },
    relativeOrFriendNameInOrganization: { isValid: true, msg: "" },
    isReadyForBusinessTrip: { isValid: true, msg: "" },
    isWillingToProvideFinancialGuarantee: { isValid: true, msg: "" },
    companyFamiliarityMethodsEnum: { isValid: true, msg: "" },
    companyFamiliarityOtherMethod: { isValid: true, msg: "" },
    referrerName: { isValid: true, msg: "" },
    startWorkSchedules: { isValid: true, msg: "" },
    businessUnit: { isValid: true, msg: "" },
    mainOffice: { isValid: true, msg: "" },
    otherOffices: { isValid: true, msg: "" },
    mainOrganizationalTitle: { isValid: true, msg: "" },
    otherInterestedInOrganizationalTitles: { isValid: true, msg: "" },
    corporateChart: { isValid: true, msg: "" },
    processVersion: { isValid: true, msg: "" },
    ci_personnel: [
      {
        personnelCode: { isValid: true, msg: "" },
        internalPhoneNumber: { isValid: true, msg: "" },
        insuranceCode: { isValid: true, msg: "" },
        insuranceDate: { isValid: true, msg: "" },
        // financialGuaranteeValue: { isValid: true, msg: "" },
        // financialGuaranteeTypeEnum: { isValid: true, msg: "" },
        // guarantorName: { isValid: true, msg: "" },
        isActive: { isValid: true, msg: "" },
        ci_personnelFiles: { isValid: true, msg: "" },
        ci_personnelContracts: { isValid: true, msg: "" },
        editingFieldsOfMainObject: { isValid: true, msg: "" },
        relatedMainObject: { isValid: true, msg: "" },
        ci_personnelBankAccounts: [
          {
            bankAccountNumber: { isValid: true, msg: "" },
            ibanCode: { isValid: true, msg: "" },
            isActive: { isValid: true, msg: "" },
            isDefault: { isValid: true, msg: "" },
            isForThirdParty: { isValid: true, msg: "" },
            bankAccountOwnerFullName: { isValid: true, msg: "" },
            relationWithPersonnel: { isValid: true, msg: "" },
            otherIndividualIntroductionDocument: { isValid: true, msg: "" },
            bankBranch: { isValid: true, msg: "" },
            editingFieldsOfMainObject: { isValid: true, msg: "" },
            relatedMainObject: { isValid: true, msg: "" },
          },
        ],
      },
    ],
    eci_personnelInformation: {
      editingFieldsOfMainObject: { isValid: true, msg: "" },
      relatedMainObject: { isValid: true, msg: "" },
      eci_person: {
        fatherName: { isValid: true, msg: "" },
        certifNumber: { isValid: true, msg: "" },
        birthplace: { isValid: true, msg: "" },
        certifSerialNumber: { isValid: true, msg: "" },
        certifIssuanceDate: { isValid: true, msg: "" },
        maritalStatusEnum: { isValid: true, msg: "" },
        militaryStatusEnum: { isValid: true, msg: "" },
        healthProblems: { isValid: true, msg: "" },
        hasClassOneDriversLicense: { isValid: true, msg: "" },
        hasClassTwoDriversLicense: { isValid: true, msg: "" },
        hasBikeLicense: { isValid: true, msg: "" },
        birthCertificateIssuingPlace: { isValid: true, msg: "" },
        bloodTypeEnum: { isValid: true, msg: "" },
        nationalCode: { isValid: true, msg: "" },
        firstName: { isValid: true, msg: "" },
        lastName: { isValid: true, msg: "" },
        birthDate: { isValid: true, msg: "" },
        genderEnum: { isValid: true, msg: "" },
        cellphone: { isValid: true, msg: "" },
        email: { isValid: true, msg: "" },
        nationalityEnum: { isValid: true, msg: "" },
        isActive: { isValid: true, msg: "" },
        eci_personContactInfos: [
          {
            value: { isValid: true, msg: "" },
            contactInfoTypeEnum: { isValid: true, msg: "" },
            editingFieldsOfMainObject: { isValid: true, msg: "" },
            relatedMainObject: { isValid: true, msg: "" },
          },
          {
            value: { isValid: true, msg: "" },
            contactInfoTypeEnum: { isValid: true, msg: "" },
            editingFieldsOfMainObject: { isValid: true, msg: "" },
            relatedMainObject: { isValid: true, msg: "" },
          },
        ],
        eci_personAddresses: [
          {
            address: { isValid: true, msg: "" },
            postalCode: { isValid: true, msg: "" },
            countryEnum: { isValid: true, msg: "" },
            latitude: { isValid: true, msg: "" },
            longitude: { isValid: true, msg: "" },
            addressTypeEnum: { isValid: true, msg: "" },
            province: { isValid: true, msg: "" },
            eci_personAddressContactInfos: [
              { value: { isValid: true, msg: "" } },
              { value: { isValid: true, msg: "" } },
            ],
            city: { isValid: true, msg: "" },
            editingFieldsOfMainObject: { isValid: true, msg: "" },
            relatedMainObject: { isValid: true, msg: "" },
          },
          {
            address: { isValid: true, msg: "" },
            postalCode: { isValid: true, msg: "" },
            countryEnum: { isValid: true, msg: "" },
            latitude: { isValid: true, msg: "" },
            longitude: { isValid: true, msg: "" },
            addressTypeEnum: { isValid: true, msg: "" },
            province: { isValid: true, msg: "" },
            eci_personAddressContactInfos: [
              { value: { isValid: true, msg: "" } },
              { value: { isValid: true, msg: "" } },
            ],
            city: { isValid: true, msg: "" },
            editingFieldsOfMainObject: { isValid: true, msg: "" },
            relatedMainObject: { isValid: true, msg: "" },
          },
        ],
        personTags: { isValid: true, msg: "" },
        personTitle: { isValid: true, msg: "" },
        editingFieldsOfMainObject: { isValid: true, msg: "" },
        relatedMainObject: { isValid: true, msg: "" },
      },

      eci_educationalBackgrounds: [
        {
          startDate: { isValid: true, msg: "" },
          finishDate: { isValid: true, msg: "" },
          thesisAim: { isValid: true, msg: "" },
          favoriteUnits: { isValid: true, msg: "" },
          gradePointAverage: { isValid: true, msg: "" },
          otherInstitute: { isValid: true, msg: "" },
          degreeLevelEnum: { isValid: true, msg: "" },
          academicOrientation: { isValid: true, msg: "" },
          major: { isValid: true, msg: "" },
          educationalInstitute: { isValid: true, msg: "" },
          editingFieldsOfMainObject: { isValid: true, msg: "" },
          relatedMainObject: { isValid: true, msg: "" },
          currentlyStudying: { isValid: true, msg: "" },
          faculty: { isValid: true, msg: "" },
        },
      ],
      eci_competencies: [
        {
          id: { isValid: true, msg: "" },
          levelOfProficiency: { isValid: true, msg: "" },
          competencyName: { isValid: true, msg: "" },
        },
      ],
      eci_foreignLanguages: [
        {
          id: { isValid: true, msg: "" },
          languageName: { isValid: true, msg: "" },
          listening: { isValid: true, msg: "" },
          writing: { isValid: true, msg: "" },
          reading: { isValid: true, msg: "" },
          speaking: { isValid: true, msg: "" },
        },
      ],
      eci_recommenders: [
        {
          fullName: { isValid: true, msg: "" },
          age: { isValid: true, msg: "" },
          cellphone: { isValid: true, msg: "" },
          job: { isValid: true, msg: "" },
          workplace: { isValid: true, msg: "" },
          relation: { isValid: true, msg: "" },
          editingFieldsOfMainObject: { isValid: true, msg: "" },
          relatedMainObject: { isValid: true, msg: "" },
        },
      ],
      eci_personnelInformationFiles: [
        {
          personnelFileTypeEnum: { isValid: true, msg: "" },
          isActive: { isValid: true, msg: "" },
          eci_personnelInformation: { isValid: true, msg: "" },
          fileStorage: { isValid: true, msg: "" },
          editingFieldsOfMainObject: { isValid: true, msg: "" },
          relatedMainObject: { isValid: true, msg: "" },
        },
      ],
      eci_courses: [
        {
          title: { isValid: true, msg: "" },
          startDate: { isValid: true, msg: "" },
          duration: { isValid: true, msg: "" },
          hasDiploma: { isValid: true, msg: "" },
          otherInstitute: { isValid: true, msg: "" },
          educationalInstitute: { isValid: true, msg: "" },
          editingFieldsOfMainObject: { isValid: true, msg: "" },
          relatedMainObject: { isValid: true, msg: "" },
        },
      ],
      eci_familyMembers: [
        {
          fullName: { isValid: true, msg: "" },
          familyRelationEnum: { isValid: true, msg: "" },
          age: { isValid: true, msg: "" },
          job: { isValid: true, msg: "" },
          cellphone: { isValid: true, msg: "" },
          workplace: { isValid: true, msg: "" },
          isDead: { isValid: true, msg: "" },
          editingFieldsOfMainObject: { isValid: true, msg: "" },
          relatedMainObject: { isValid: true, msg: "" },
        },
        {
          fullName: { isValid: true, msg: "" },
          familyRelationEnum: { isValid: true, msg: "" },
          age: { isValid: true, msg: "" },
          job: { isValid: true, msg: "" },
          cellphone: { isValid: true, msg: "" },
          workplace: { isValid: true, msg: "" },
          isDead: { isValid: true, msg: "" },
          editingFieldsOfMainObject: { isValid: true, msg: "" },
          relatedMainObject: { isValid: true, msg: "" },
        },
        {
          fullName: { isValid: true, msg: "" },
          familyRelationEnum: { isValid: true, msg: "" },
          age: { isValid: true, msg: "" },
          job: { isValid: true, msg: "" },
          cellphone: { isValid: true, msg: "" },
          workplace: { isValid: true, msg: "" },
          isDead: { isValid: true, msg: "" },
          editingFieldsOfMainObject: { isValid: true, msg: "" },
          relatedMainObject: { isValid: true, msg: "" },
        },
      ],
      eci_workExperiences: [
        {
          employer: { isValid: true, msg: "" },
          post: { isValid: true, msg: "" },
          directManagerName: { isValid: true, msg: "" },
          directManagerCellphone: { isValid: true, msg: "" },
          salary: { isValid: true, msg: "" },
          resigningReason: { isValid: true, msg: "" },
          startDate: { isValid: true, msg: "" },
          finishDate: { isValid: true, msg: "" },
          editingFieldsOfMainObject: { isValid: true, msg: "" },
          relatedMainObject: { isValid: true, msg: "" },
        },
        {
          employer: { isValid: true, msg: "" },
          post: { isValid: true, msg: "" },
          directManagerName: { isValid: true, msg: "" },
          directManagerCellphone: { isValid: true, msg: "" },
          salary: { isValid: true, msg: "" },
          resigningReason: { isValid: true, msg: "" },
          startDate: { isValid: true, msg: "" },
          finishDate: { isValid: true, msg: "" },
          editingFieldsOfMainObject: { isValid: true, msg: "" },
          relatedMainObject: { isValid: true, msg: "" },
        },
        {
          employer: { isValid: true, msg: "" },
          post: { isValid: true, msg: "" },
          directManagerName: { isValid: true, msg: "" },
          directManagerCellphone: { isValid: true, msg: "" },
          salary: { isValid: true, msg: "" },
          resigningReason: { isValid: true, msg: "" },
          startDate: { isValid: true, msg: "" },
          finishDate: { isValid: true, msg: "" },
          editingFieldsOfMainObject: { isValid: true, msg: "" },
          relatedMainObject: { isValid: true, msg: "" },
        },
      ],
      eci_policeClearanceCertificates: [
        {
          policeClearanceCertificateDate: { isValid: true, msg: "" },
          policeClearanceCertificateCode: { isValid: true, msg: "" },
          fileStorage: { isValid: true, msg: "" },
          editingFieldsOfMainObject: { isValid: true, msg: "" },
          relatedMainObject: { isValid: true, msg: "" },
        },
      ],
    },
  };
  const fieldNameAddresses = {
    ECIFamilyMember: {
      ECIFamilyMember_age: "eci_personnelInformation.eci_familyMembers.[].age",
      ECIFamilyMember_cellphone: "eci_personnelInformation.eci_familyMembers.[].cellphone",
      ECIFamilyMember_fullName: "eci_personnelInformation.eci_familyMembers.[].fullName",
      ECIFamilyMember_job: "eci_personnelInformation.eci_familyMembers.[].job",
      ECIFamilyMember_workplace: "eci_personnelInformation.eci_familyMembers.[].workplace",
      ECIFamilyMember_familyRelationEnum:
        "eci_personnelInformation.eci_familyMembers.[].familyRelationEnum",
      ECIFamilyMember_workplace: "eci_personnelInformation.eci_familyMembers.[].workplace",
    },
    ECICompetency: {
      ECICompetency_levelOfProficiency:
        "eci_personnelInformation.eci_competencies.[].levelOfProficiency",
      ECICompetency_competencyName: "eci_personnelInformation.eci_competencies.[].competencyName",
    },
    ECIForeignLanguage: {
      ECIForeignLanguage_languageName: "eci_personnelInformation.eci_foreignLanguages.[].languageName",
      ECIForeignLanguage_listening: "eci_personnelInformation.eci_foreignLanguages.[].listening",
      ECIForeignLanguage_writing: "eci_personnelInformation.eci_foreignLanguages.[].writing",
      ECIForeignLanguage_reading: "eci_personnelInformation.eci_foreignLanguages.[].reading",
      ECIForeignLanguage_speaking: "eci_personnelInformation.eci_foreignLanguages.[].speaking",
    },
    ECIPersonContactInfo: {
      ECIPersonContactInfo_value: "eci_personnelInformation.eci_person.eci_personContactInfos.[].value",
      ECIPersonContactInfo_contactInfoTypeEnum:
        "eci_personnelInformation.eci_person.eci_personContactInfos.[].contactInfoTypeEnum",
    },
    ECIPersonnelInformation: {
      ECIPersonnelInformation_ecifamilyMembers: "eci_personnelInformation.eci_familyMembers",
      ECIPersonnelInformation_cipersonnelBankAccounts:
        "eci_personnelInformation.ci_personnelBankAccounts",
      ECIPersonnelInformation_ecicourses: "eci_personnelInformation.eci_courses",
      ECIPersonnelInformation_ecicompetencies: "eci_personnelInformation.eci_competencies",
      ECIPersonnelInformation_eciforeignLanguages: "eci_personnelInformation.eci_foreignLanguages",
      ECIPersonnelInformation_ciperson: "eci_personnelInformation.eci_person",

      ECIPersonnelInformation_ecieducationalBackgrounds:
        "eci_personnelInformation.eci_educationalBackgrounds",
      ECIPersonnelInformation_ecirecommenders: "eci_personnelInformation.eci_recommenders",
      ECIPersonnelInformation_ecipersonnelInformationFiles:
        "eci_personnelInformation.eci_personnelInformationFiles",
      ECIPersonnelInformation_eciworkExperiences: "eci_personnelInformation.eci_workExperiences",
      ECIPersonnelInformation_ecipoliceClearanceCertificates:
        "eci_personnelInformation.eci_policeClearanceCertificates",
    },
    ECIPersonAddress: {
      ECIPersonAddress_city: "eci_personnelInformation.eci_person.eci_personAddresses.[].city",
      ECIPersonAddress_province: "eci_personnelInformation.eci_person.eci_personAddresses.[].province",
      ECIPersonAddress_address: "eci_personnelInformation.eci_person.eci_personAddresses.[].address",
      ECIPersonAddress_longitude: "eci_personnelInformation.eci_person.eci_personAddresses.[].longitude",
      ECIPersonAddress_latitude: "eci_personnelInformation.eci_person.eci_personAddresses.[].latitude",
      ECIPersonAddress_postalCode:
        "eci_personnelInformation.eci_person.eci_personAddresses.[].postalCode",
      ECIPersonAddress_ecipersonAddressesContactInfos:
        "eci_personnelInformation.eci_person.eci_personAddresses.[].eci_personAddressContactInfos",
      ECIPersonAddress_countryEnum:
        "eci_personnelInformation.eci_person.eci_personAddresses.[].countryEnum",
      ECIPersonAddress_latitude: "eci_personnelInformation.eci_person.eci_personAddresses.[].latitude",
      ECIPersonAddress_longitude: "eci_personnelInformation.eci_person.eci_personAddresses.[].longitude",
      ECIPersonAddress_addressTypeEnum:
        "eci_personnelInformation.eci_person.eci_personAddresses.[].addressTypeEnum",
    },
    ECIPersonAddressContactInfo: {
      ECIPersonAddressContactInfo_value:
        "eci_personnelInformation.eci_person.eci_personAddresses.[].eci_personAddressContactInfos.[].value",
    },
    ECIRecommender: {
      ECIRecommender_relation: "eci_personnelInformation.eci_recommenders.[].relation",
      ECIRecommender_cellphone: "eci_personnelInformation.eci_recommenders.[].cellphone",
      ECIRecommender_age: "eci_personnelInformation.eci_recommenders.[].age",
      ECIRecommender_fullName: "eci_personnelInformation.eci_recommenders.[].fullName",
      ECIRecommender_job: "eci_personnelInformation.eci_recommenders.[].job",
      ECIRecommender_workplace: "eci_personnelInformation.eci_recommenders.[].workplace",
    },
    ECIWorkExperience: {
      ECIWorkExperience_directManagerCellphone:
        "eci_personnelInformation.eci_workExperiences.[].directManagerCellphone",
      ECIWorkExperience_directManagerName:
        "eci_personnelInformation.eci_workExperiences.[].directManagerName",
      ECIWorkExperience_salary: "eci_personnelInformation.eci_workExperiences.[].salary",
      ECIWorkExperience_workshopInsuranceCode:
        "eci_personnelInformation.eci_workExperiences.[].workshopInsuranceCode",
      ECIWorkExperience_startDate: "eci_personnelInformation.eci_workExperiences.[].startDate",
      ECIWorkExperience_employer: "eci_personnelInformation.eci_workExperiences.[].employer",
      ECIWorkExperience_resigningReason:
        "eci_personnelInformation.eci_workExperiences.[].resigningReason",
      ECIWorkExperience_post: "eci_personnelInformation.eci_workExperiences.[].post",
      ECIWorkExperience_finishDate: "eci_personnelInformation.eci_workExperiences.[].finishDate",
    },
    JobApply: {
      JobApply_businessUnit: "businessUnit",
      JobApply_financialGuaranteeValue: "financialGuaranteeValue",
      JobApply_financialGuaranteeTypeEnum: "financialGuaranteeTypeEnum",
      JobApply_guarantorName: "guarantorName",
      JobApply_salaryExpectation: "salaryExpectation",
      JobApply_lastName: "lastName",
      JobApply_cellphone: "cellphone",
      JobApply_nationalCode: "nationalCode",
      JobApply_firstName: "firstName",
      JobApply_workStartDate: "workStartDate",
      JobApply_corporateChart: "corporateChart",
      JobApply_relativeOrFriendNameInOrganization: "relativeOrFriendNameInOrganization",
      JobApply_hasRelativeOrFriendInOrganization: "hasRelativeOrFriendInOrganization",
      JobApply_isReadyForBusinessTrip: "isReadyForBusinessTrip",
      JobApply_isWillingToProvideFinancialGuarantee: "isWillingToProvideFinancialGuarantee",
      JobApply_companyFamiliarityMethodsEnum: "companyFamiliarityMethodsEnum",
      JobApply_companyFamiliarityOtherMethod: "companyFamiliarityOtherMethod",
      JobApply_referrerName: "referrerName",
      JobApply_readyToStartWorkDate: "readyToStartWorkDate",
      JobApply_preferredTimeZone: "preferredTimeZone",
      JobApply_preferredLanguage: "preferredLanguage",
      JobApply_preferredCalendar: "preferredCalendar",
      JobApply_personnelSalaryDifferenceValue: "personnelSalaryDifferenceValue",
      JobApply_personnelSalaryDifferenceToDate: "personnelSalaryDifferenceToDate",
      JobApply_state: "state",
      JobApply_stateEnglishName: "stateEnglishName",
      JobApply_documentSubmissionSchedules: "documentSubmissionSchedules",
      JobApply_startWorkSchedules: "startWorkSchedules",
      JobApply_mainOffice: "mainOffice",
      JobApply_otherOffices: "otherOffices",
      JobApply_mainOrganizationalTitle: "mainOrganizationalTitle",
      JobApply_otherInterestedInOrganizationalTitles: "otherInterestedInOrganizationalTitles",
      JobApply_processVersion: "processVersion",
      JobApply_ecipersonnelInformation: "eci_personnelInformation",
      JobApply_cipersonnel: "ci_personnel",
    },
    ECIPerson: {
      ECIPerson_email: "eci_personnelInformation.eci_person.email",
      ECIPerson_fatherName: "eci_personnelInformation.eci_person.fatherName",
      ECIPerson_certifSerialNumber: "eci_personnelInformation.eci_person.certifSerialNumber",
      ECIPerson_certifNumber: "eci_personnelInformation.eci_person.certifNumber",
      ECIPerson_lastName: "eci_personnelInformation.eci_person.lastName",
      ECIPerson_cellphone: "eci_personnelInformation.eci_person.cellphone",
      ECIPerson_nationalCode: "eci_personnelInformation.eci_person.nationalCode",
      ECIPerson_firstName: "eci_personnelInformation.eci_person.firstName",
      ECIPerson_genderEnum: "eci_personnelInformation.eci_person.genderEnum",
      ECIPerson_ecipersonAddresses: "eci_personnelInformation.eci_person.eci_personAddresses",
      ECIPerson_bloodTypeEnum: "eci_personnelInformation.eci_person.bloodTypeEnum",
      ECIPerson_birthplace: "eci_personnelInformation.eci_person.birthplace",
      ECIPerson_birthCertificateIssuingPlace:
        "eci_personnelInformation.eci_person.birthCertificateIssuingPlace",
      ECIPerson_militaryStatusEnum: "eci_personnelInformation.eci_person.militaryStatusEnum",
      ECIPerson_certifIssuanceDate: "eci_personnelInformation.eci_person.certifIssuanceDate",
      ECIPerson_maritalStatusEnum: "eci_personnelInformation.eci_person.maritalStatusEnum",
      ECIPerson_birthDate: "eci_personnelInformation.eci_person.birthDate",
      ECIPerson_healthProblems: "eci_personnelInformation.eci_person.healthProblems",
      ECIPerson_hasClassOneDriversLicense:
        "eci_personnelInformation.eci_person.hasClassOneDriversLicense",
      ECIPerson_hasClassTwoDriversLicense:
        "eci_personnelInformation.eci_person.hasClassTwoDriversLicense",
      ECIPerson_hasBikeLicense: "eci_personnelInformation.eci_person.hasBikeLicense",
      ECIPerson_lifeStatusEnum: "eci_personnelInformation.eci_person.lifeStatusEnum",
      ECIPerson_nationalityEnum: "eci_personnelInformation.eci_person.nationalityEnum",
      ECIPerson_isActive: "eci_personnelInformation.eci_person.isActive",
      ECIPerson_ecipersonContactInfos: "eci_personnelInformation.eci_person.eci_personContactInfos",
      ECIPerson_personTags: "eci_personnelInformation.eci_person.personTags",
      ECIPerson_personTitle: "eci_personnelInformation.eci_person.personTitle",
    },
    ECICourse: {
      ECICourse_title: "eci_personnelInformation.eci_courses.[].title",
      ECICourse_duration: "eci_personnelInformation.eci_courses.[].duration",
      ECICourse_startDate: "eci_personnelInformation.eci_courses.[].startDate",
      ECICourse_hasDiploma: "eci_personnelInformation.eci_courses.[].hasDiploma",
      ECICourse_otherInstitute: "eci_personnelInformation.eci_courses.[].otherInstitute",
      ECICourse_educationalInstitute: "eci_personnelInformation.eci_courses.[].educationalInstitute",
    },
    ECIEducationalBackground: {
      ECIEducationalBackground_major: "eci_personnelInformation.eci_educationalBackgrounds.[].major",
      ECIEducationalBackground_gradePointAverage:
        "eci_personnelInformation.eci_educationalBackgrounds.[].gradePointAverage",
      ECIEducationalBackground_startDate:
        "eci_personnelInformation.eci_educationalBackgrounds.[].startDate",
      ECIEducationalBackground_degreeLevelEnum:
        "eci_personnelInformation.eci_educationalBackgrounds.[].degreeLevelEnum",
      ECIEducationalBackground_currentlyStudying:
        "eci_personnelInformation.eci_educationalBackgrounds.[].currentlyStudying",
      ECIEducationalBackground_faculty: "eci_personnelInformation.eci_educationalBackgrounds.[].faculty",
      ECIEducationalBackground_finishDate:
        "eci_personnelInformation.eci_educationalBackgrounds.[].finishDate",
      ECIEducationalBackground_thesisAim:
        "eci_personnelInformation.eci_educationalBackgrounds.[].thesisAim",
      ECIEducationalBackground_favoriteUnits:
        "eci_personnelInformation.eci_educationalBackgrounds.[].favoriteUnits",
      ECIEducationalBackground_gradePointAverage:
        "eci_personnelInformation.eci_educationalBackgrounds.[].gradePointAverage",
      ECIEducationalBackground_otherInstitute:
        "eci_personnelInformation.eci_educationalBackgrounds.[].otherInstitute",
      ECIEducationalBackground_academicOrientation:
        "eci_personnelInformation.eci_educationalBackgrounds.[].academicOrientation",
      ECIEducationalBackground_educationalInstitute:
        "eci_personnelInformation.eci_educationalBackgrounds.[].educationalInstitute",
      ECIEducationalBackground_currentlyStudying:
        "eci_personnelInformation.eci_educationalBackgrounds.[].currentlyStudying",
      ECIEducationalBackground_faculty: "eci_personnelInformation.eci_educationalBackgrounds.[].faculty",
    },
    CIPersonnel: {
      CIPersonnel_insuranceCode: "ci_personnel.insuranceCode",
      CIPersonnel_insuranceDate: "ci_personnel.insuranceDate",
      CIPersonnel_personnelCode: "ci_personnel.personnelCode",
      CIPersonnel_internalPhoneNumber: "ci_personnel.internalPhoneNumber",
      CIPersonnel_isActive: "ci_personnel.isActive",
      CIPersonnel_cipersonnelFiles: "ci_personnel.ci_personnelFiles",
      CIPersonnel_cipersonnelContracts: "ci_personnel.ci_personnelContracts",
      CIPersonnel_cipersonnelBankAccounts: "ci_personnel.ci_personnelBankAccounts",
    },
    CIPersonnelBankAccount: {
      CIPersonnelBankAccount_bankAccountNumber:
        "ci_personnel.ci_personnelBankAccounts.[].bankAccountNumber",
      CIPersonnelBankAccount_isActive: "ci_personnel.ci_personnelBankAccounts.[].isActive",
      CIPersonnelBankAccount_isDefault: "ci_personnel.ci_personnelBankAccounts.[].isDefault",
      CIPersonnelBankAccount_bankBranch: "ci_personnel.ci_personnelBankAccounts.[].bankBranch",
      CIPersonnelBankAccount_bankAccountOwnerFullName:
        "ci_personnel.ci_personnelBankAccounts.[].bankAccountOwnerFullName",
      CIPersonnelBankAccount_bankAccountOwner:
        "ci_personnel.ci_personnelBankAccounts.[].bankAccountOwner",
      CIPersonnelBankAccount_ibanCode: "ci_personnel.ci_personnelBankAccounts.[].ibanCode",
      CIPersonnelBankAccount_relationWithPersonnel:
        "ci_personnel.ci_personnelBankAccounts.[].relationWithPersonnel",
      CIPersonnelBankAccount_isForThirdParty: "ci_personnel.ci_personnelBankAccounts.[].isForThirdParty",
      CIPersonnelBankAccount_otherIndividualIntroductionDocument:
        "ci_personnel.ci_personnelBankAccounts.[].otherIndividualIntroductionDocument",
    },
    ECIPersonnelInformationFile: {
      ECIPersonnelInformationFile_personnelFileTypeEnum:
        "eci_personnelInformation.eci_personnelInformationFiles.[].personnelFileTypeEnum",
      ECIPersonnelInformationFile_fileStorage:
        "eci_personnelInformation.eci_personnelInformationFiles.[].fileStorage",
      ECIPersonnelInformationFile_isActive:
        "eci_personnelInformation.eci_personnelInformationFiles.[].isActive",
    },
    ECIPoliceClearanceCertificate: {
      ECIPoliceClearanceCertificate_policeClearanceCertificateDate:
        "eci_personnelInformation.eci_policeClearanceCertificates.[].policeClearanceCertificateDate",
      ECIPoliceClearanceCertificate_policeClearanceCertificateCode:
        "eci_personnelInformation.eci_policeClearanceCertificates.[].policeClearanceCertificateCode",
      ECIPoliceClearanceCertificate_fileStorage:
        "eci_personnelInformation.eci_policeClearanceCertificates.[].fileStorage",
    },
  };
  const personnelInformationDtoToView = (dtos) => {
    let views = personnelInformationView;

    views.id = dtos?.id;
    views.firstName = dtos?.firstName == null ? null : dtos.firstName;
    views.lastName = dtos?.lastName == null ? null : dtos.lastName;
    views.nationalCode = dtos?.nationalCode == null ? null : dtos.nationalCode;
    views.cellphone = dtos?.cellphone == null ? null : `0${dtos.cellphone?.slice(3)}`;
    views.workStartDate = dtos?.workStartDate == null ? null : dtos.workStartDate;
    views.salaryExpectation = dtos?.salaryExpectation == null ? null : dtos.salaryExpectation;
    views.readyToStartWorkDate = dtos?.readyToStartWorkDate == null ? null : dtos.readyToStartWorkDate;
    views.financialGuaranteeValue =
      dtos?.financialGuaranteeValue == null ? null : dtos.financialGuaranteeValue;
    views.financialGuaranteeTypeEnum =
      dtos?.financialGuaranteeTypeEnum == null ? null : dtos.financialGuaranteeTypeEnum;
    views.guarantorName = dtos?.guarantorName == null ? null : dtos.guarantorName;
    views.hasRelativeOrFriendInOrganization =
      dtos?.hasRelativeOrFriendInOrganization == null ? null : dtos.hasRelativeOrFriendInOrganization;
    views.relativeOrFriendNameInOrganization =
      dtos?.relativeOrFriendNameInOrganization == null ? null : dtos.relativeOrFriendNameInOrganization;
    views.isReadyForBusinessTrip =
      dtos?.isReadyForBusinessTrip == null ? null : dtos.isReadyForBusinessTrip;
    views.isWillingToProvideFinancialGuarantee =
      dtos?.isWillingToProvideFinancialGuarantee == null
        ? null
        : dtos.isWillingToProvideFinancialGuarantee;

    views.companyFamiliarityMethodsEnum =
      dtos?.companyFamiliarityMethodsEnum == null ? null : dtos.companyFamiliarityMethodsEnum;
    views.companyFamiliarityOtherMethod =
      dtos?.companyFamiliarityOtherMethod == null ? null : dtos.companyFamiliarityOtherMethod;
    views.referrerName = dtos?.referrerName == null ? null : dtos.referrerName;
    views.preferredTimeZone = dtos?.preferredTimeZone == null ? null : dtos.preferredTimeZone;
    views.preferredLanguage = dtos?.preferredLanguage == null ? null : dtos.preferredLanguage;
    views.preferredCalendar = dtos?.preferredCalendar == null ? null : dtos.preferredCalendar;
    views.personnelSalaryDifferenceValue =
      dtos?.personnelSalaryDifferenceValue == null ? null : dtos.personnelSalaryDifferenceValue;
    views.personnelSalaryDifferenceToDate =
      dtos?.personnelSalaryDifferenceToDate == null ? null : dtos.personnelSalaryDifferenceToDate;
    views.state = dtos?.state == null ? null : dtos.state;
    views.stateEnglishName = dtos?.stateEnglishName == null ? null : dtos.stateEnglishName;
    views.documentSubmissionSchedules =
      dtos?.documentSubmissionSchedules == null ? null : dtos.documentSubmissionSchedules;
    views.startWorkSchedules = dtos?.startWorkSchedules == null ? null : dtos.startWorkSchedules;
    views.businessUnit = dtos?.businessUnit == null ? null : dtos.businessUnit;
    views.mainOffice = dtos?.mainOffice == null ? null : dtos.mainOffice;
    // views.otherOffices = dtos?.otherOffices == null ? null : dtos.otherOffices;
    views.otherOffices = dtos?.otherOffices?.filter((off) => off.id)?.length ? dtos.otherOffices : null;
    views.mainOrganizationalTitle =
      dtos?.mainOrganizationalTitle == null ? null : dtos.mainOrganizationalTitle;
    // views.otherInterestedInOrganizationalTitles =
    //   dtos?.otherInterestedInOrganizationalTitles == null
    //     ? null
    //     : dtos.otherInterestedInOrganizationalTitles;
    views.otherInterestedInOrganizationalTitles = dtos?.otherInterestedInOrganizationalTitles?.filter(
      (orgT) => orgT.id
    )?.length
      ? dtos.otherInterestedInOrganizationalTitles
      : null;
    views.corporateChart = dtos?.corporateChart == null ? null : dtos.corporateChart;
    views.processVersion = dtos?.processVersion == null ? null : dtos.processVersion;
    // eci_personnelInformation
    views.eci_personnelInformation.id = dtos?.eci_personnelInformation?.id;
    views.eci_personnelInformation.editingFieldsOfMainObject =
      dtos?.eci_personnelInformation?.editingFieldsOfMainObject == null
        ? null
        : dtos.eci_personnelInformation.editingFieldsOfMainObject;
    views.eci_personnelInformation.relatedMainObject =
      dtos?.eci_personnelInformation?.relatedMainObject == null
        ? null
        : dtos.eci_personnelInformation.relatedMainObject;
    views.eci_personnelInformation.jobApply =
      dtos?.eci_personnelInformation?.jobApply == null ? null : dtos.eci_personnelInformation.jobApply;
    // eci_person
    views.eci_personnelInformation.eci_person.id =
      dtos.eci_personnelInformation.eci_person?.id == null
        ? null
        : dtos.eci_personnelInformation.eci_person.id;
    views.eci_personnelInformation.eci_person.fatherName =
      dtos.eci_personnelInformation.eci_person?.fatherName == null
        ? null
        : dtos.eci_personnelInformation.eci_person.fatherName;
    views.eci_personnelInformation.eci_person.certifNumber =
      dtos.eci_personnelInformation.eci_person.certifNumber == null
        ? null
        : dtos.eci_personnelInformation.eci_person.certifNumber;
    views.eci_personnelInformation.eci_person.birthplace =
      dtos.eci_personnelInformation.eci_person?.birthplace == null
        ? null
        : dtos.eci_personnelInformation.eci_person.birthplace;
    views.eci_personnelInformation.eci_person.certifSerialNumber =
      dtos.eci_personnelInformation.eci_person?.certifSerialNumber == null
        ? null
        : dtos.eci_personnelInformation.eci_person.certifSerialNumber;
    views.eci_personnelInformation.eci_person.certifIssuanceDate =
      dtos.eci_personnelInformation.eci_person?.certifIssuanceDate == null
        ? null
        : dtos.eci_personnelInformation.eci_person.certifIssuanceDate;
    views.eci_personnelInformation.eci_person.maritalStatusEnum =
      dtos.eci_personnelInformation.eci_person?.maritalStatusEnum == null
        ? null
        : dtos.eci_personnelInformation.eci_person.maritalStatusEnum;
    views.eci_personnelInformation.eci_person.militaryStatusEnum =
      dtos.eci_personnelInformation.eci_person?.militaryStatusEnum == null
        ? null
        : dtos.eci_personnelInformation.eci_person.militaryStatusEnum;
    views.eci_personnelInformation.eci_person.healthProblems =
      dtos.eci_personnelInformation.eci_person?.healthProblems == null
        ? null
        : dtos.eci_personnelInformation.eci_person.healthProblems;
    views.eci_personnelInformation.eci_person.hasClassOneDriversLicense =
      dtos.eci_personnelInformation.eci_person?.hasClassOneDriversLicense == null
        ? null
        : dtos.eci_personnelInformation.eci_person.hasClassOneDriversLicense;
    views.eci_personnelInformation.eci_person.hasClassTwoDriversLicense =
      dtos.eci_personnelInformation.eci_person?.hasClassTwoDriversLicense == null
        ? null
        : dtos.eci_personnelInformation.eci_person.hasClassTwoDriversLicense;
    views.eci_personnelInformation.eci_person.hasBikeLicense =
      dtos.eci_personnelInformation.eci_person?.hasBikeLicense == null
        ? null
        : dtos.eci_personnelInformation.eci_person.hasBikeLicense;
    views.eci_personnelInformation.eci_person.birthCertificateIssuingPlace =
      dtos.eci_personnelInformation.eci_person?.birthCertificateIssuingPlace == null
        ? null
        : dtos.eci_personnelInformation.eci_person.birthCertificateIssuingPlace;
    views.eci_personnelInformation.eci_person.bloodTypeEnum =
      dtos.eci_personnelInformation.eci_person?.bloodTypeEnum == null
        ? null
        : dtos.eci_personnelInformation.eci_person.bloodTypeEnum;
    views.eci_personnelInformation.eci_person.nationalCode =
      dtos.eci_personnelInformation.eci_person?.nationalCode == null
        ? null
        : dtos.eci_personnelInformation.eci_person.nationalCode;
    views.eci_personnelInformation.eci_person.firstName =
      dtos.eci_personnelInformation.eci_person?.firstName == null
        ? null
        : dtos.eci_personnelInformation.eci_person.firstName;
    views.eci_personnelInformation.eci_person.lastName =
      dtos.eci_personnelInformation.eci_person?.lastName == null
        ? null
        : dtos.eci_personnelInformation.eci_person.lastName;
    views.eci_personnelInformation.eci_person.birthDate =
      dtos.eci_personnelInformation.eci_person?.birthDate == null
        ? null
        : dtos.eci_personnelInformation.eci_person.birthDate;
    views.eci_personnelInformation.eci_person.genderEnum =
      dtos.eci_personnelInformation.eci_person?.genderEnum == null
        ? null
        : dtos.eci_personnelInformation.eci_person.genderEnum;
    // views.eci_personnelInformation.eci_person.lifeStatusEnum =
    //   dtos.eci_personnelInformation.eci_person?.lifeStatusEnum == null
    //     ? null
    //     : dtos.eci_personnelInformation.eci_person.lifeStatusEnum;
    views.eci_personnelInformation.eci_person.cellphone =
      dtos.eci_personnelInformation.eci_person?.cellphone == null
        ? null
        : `0${dtos.eci_personnelInformation.eci_person.cellphone?.slice(3)}`;
    views.eci_personnelInformation.eci_person.email =
      dtos.eci_personnelInformation.eci_person?.email == null
        ? null
        : dtos.eci_personnelInformation.eci_person.email;
    views.eci_personnelInformation.eci_person.nationalityEnum =
      dtos.eci_personnelInformation.eci_person?.nationalityEnum == null
        ? null
        : dtos.eci_personnelInformation.eci_person.nationalityEnum;
    views.eci_personnelInformation.eci_person.isActive =
      dtos.eci_personnelInformation.eci_person?.isActive;
    views.eci_personnelInformation.eci_person.personTags =
      dtos.eci_personnelInformation.eci_person.personTags?.filter((tag) => tag.id)?.length
        ? dtos.eci_personnelInformation.eci_person.personTags
        : [];
    views.eci_personnelInformation.eci_person.personTitle =
      dtos.eci_personnelInformation.eci_person?.personTitle == null
        ? null
        : dtos.eci_personnelInformation.eci_person.personTitle;
    views.eci_personnelInformation.eci_person.editingFieldsOfMainObject =
      dtos.eci_personnelInformation.eci_person?.editingFieldsOfMainObject == null
        ? null
        : dtos.eci_personnelInformation.eci_person.editingFieldsOfMainObject;
    views.eci_personnelInformation.eci_person.relatedMainObject =
      dtos.eci_personnelInformation.eci_person?.relatedMainObject == null
        ? null
        : dtos.eci_personnelInformation.eci_person.relatedMainObject;
    // eci_personContactInfos
    views.eci_personnelInformation.eci_person.eci_personContactInfos = dtos?.eci_personnelInformation
      ?.eci_person?.eci_personContactInfos
      ? dtos.eci_personnelInformation.eci_person.eci_personContactInfos
      : [];
    // eci_personAddresses
    views.eci_personnelInformation.eci_person.eci_personAddresses =
      dtos.eci_personnelInformation.eci_person.eci_personAddresses.map((addre) => {
        return {
          id: addre?.id,
          address: addre?.address === null ? null : addre?.address,
          postalCode: addre?.postalCode === null ? null : addre?.postalCode,
          countryEnum: addre?.countryEnum === null ? null : addre?.countryEnum,
          latitude: addre?.latitude === null ? null : addre?.latitude,
          longitude: addre?.longitude === null ? null : addre?.longitude,
          addressTypeEnum: addre?.addressTypeEnum?.id === null ? null : addre?.addressTypeEnum,
          province: addre?.province?.id === null ? null : addre?.province,
          eci_personAddressContactInfos: addre?.eci_personAddressContactInfos
            ? addre?.eci_personAddressContactInfos
            : [],
          city: addre?.city?.id === null ? null : addre?.city,
          eci_person: { nationalityEnum: "ایرانی" },
          editingFieldsOfMainObject:
            addre?.editingFieldsOfMainObject?.id === null ? null : addre?.editingFieldsOfMainObject,
          relatedMainObject: addre?.relatedMainObject?.id === null ? null : addre?.relatedMainObject,
        };
      });
    // ci_personnel
    views.ci_personnel[0].id = dtos.ci_personnel[0]?.id == null ? null : dtos.ci_personnel[0].id;
    views.ci_personnel[0].personnelCode =
      dtos.ci_personnel[0]?.personnelCode == null ? null : dtos.ci_personnel[0].personnelCode;
    views.ci_personnel[0].internalPhoneNumber =
      dtos.ci_personnel[0]?.internalPhoneNumber == null
        ? null
        : dtos.ci_personnel[0].internalPhoneNumber;
    views.ci_personnel[0].insuranceCode =
      dtos.ci_personnel[0]?.insuranceCode == null ? null : dtos.ci_personnel[0].insuranceCode;
    views.ci_personnel[0] = dtos.ci_personnel[0];

    views.ci_personnel[0].insuranceDate =
      dtos.ci_personnel[0]?.insuranceDate == null ? null : dtos.ci_personnel[0].insuranceDate;
    // views.ci_personnel[0].financialGuaranteeValue =
    //   dtos.ci_personnel[0]?.financialGuaranteeValue == null
    //     ? null
    //     : dtos.ci_personnel[0].financialGuaranteeValue;
    // views.ci_personnel[0].financialGuaranteeTypeEnum =
    //   dtos.ci_personnel[0]?.financialGuaranteeTypeEnum == null
    //     ? null
    //     : dtos.ci_personnel[0].financialGuaranteeTypeEnum;
    // views.ci_personnel[0].guarantorName =
    //   dtos.ci_personnel[0]?.guarantorName == null
    //     ? null
    //     : dtos.ci_personnel[0].guarantorName;
    views.ci_personnel[0].nationalityEnum = "ایرانی";

    views.ci_personnel[0].ci_personnelFiles =
      dtos.ci_personnel[0]?.ci_personnelFiles == null ? null : dtos.ci_personnel[0].ci_personnelFiles;
    views.ci_personnel[0].ci_personnelContracts =
      dtos.ci_personnel[0]?.ci_personnelContracts == null
        ? null
        : dtos.ci_personnel[0].ci_personnelContracts;

    views.ci_personnel[0].editingFieldsOfMainObject =
      dtos.ci_personnel[0]?.editingFieldsOfMainObject == null
        ? null
        : dtos.ci_personnel[0].editingFieldsOfMainObject;
    views.ci_personnel[0].relatedMainObject =
      dtos.ci_personnel[0]?.relatedMainObject == null ? null : dtos.ci_personnel[0].relatedMainObject;
    views.ci_personnel[0].isActive = dtos.ci_personnel[0]?.isActive;
    // eci_educationalBackgrounds
    views.eci_personnelInformation.eci_educationalBackgrounds = dtos?.eci_personnelInformation
      ?.eci_educationalBackgrounds?.[0]?.id
      ? dtos?.eci_personnelInformation?.eci_educationalBackgrounds
      : [];
    // eci_recommenders
    views.eci_personnelInformation.eci_recommenders = dtos?.eci_personnelInformation
      ?.eci_recommenders?.[0]?.id
      ? dtos.eci_personnelInformation.eci_recommenders.map((each) => {
          each.cellphone = each.cellphone ? `0${each.cellphone?.slice(3)}` : null;
          return each;
        })
      : [
          {
            id: null,
            fullName: null,
            age: null,
            cellphone: null,
            job: null,
            workplace: null,
            relation: null,
            editingFieldsOfMainObject: null,
            relatedMainObject: null,
          },
        ];
    // eci_courses
    views.eci_personnelInformation.eci_courses = dtos?.eci_personnelInformation?.eci_courses?.[0]?.id
      ? dtos?.eci_personnelInformation?.eci_courses
      : [];
    // eci_familyMembers
    views.eci_personnelInformation.eci_familyMembers = dtos?.eci_personnelInformation
      ?.eci_familyMembers?.[0]?.id
      ? dtos.eci_personnelInformation.eci_familyMembers.map((each) => {
          each.cellphone = each.cellphone ? `0${each.cellphone?.slice(3)}` : null;
          return each;
        })
      : [
          {
            id: null,
            fullName: null,
            familyRelationEnum: null,
            age: null,
            job: null,
            cellphone: null,
            workplace: null,
            isDead: false,
            editingFieldsOfMainObject: null,
            relatedMainObject: null,
          },
        ];
    // eci_workExperiences
    views.eci_personnelInformation.eci_workExperiences = dtos?.eci_personnelInformation
      ?.eci_workExperiences?.[0]?.id
      ? dtos.eci_personnelInformation.eci_workExperiences.map((each) => {
          each.directManagerCellphone = each.directManagerCellphone
            ? `0${each.directManagerCellphone?.slice(3)}`
            : null;
          return each;
        })
      : [];
    // eci_competencies
    views.eci_personnelInformation.eci_competencies = dtos?.eci_personnelInformation
      ?.eci_competencies?.[0]?.id
      ? dtos?.eci_personnelInformation?.eci_competencies
      : [];
    // eci_foreignLanguages
    views.eci_personnelInformation.eci_foreignLanguages = dtos?.eci_personnelInformation
      ?.eci_foreignLanguages?.[0]?.id
      ? dtos?.eci_personnelInformation?.eci_foreignLanguages
      : [];
    // eci_policeClearanceCertificates
    views.eci_personnelInformation.eci_policeClearanceCertificates = dtos?.eci_personnelInformation
      ?.eci_policeClearanceCertificates?.[0]?.id
      ? dtos.eci_personnelInformation.eci_policeClearanceCertificates?.map((each) => {
          each.tempFileStorage = {
            uploadedFile: null,
            uploadedFileReader: null,
            downloadedFile: null,
            successfullyUploadedFileId: null,
            hasChanged: null,
          };
          return each;
        })
      : [
          {
            id: null,
            policeClearanceCertificateDate: null,
            policeClearanceCertificateCode: null,
            fileStorage: null,
            tempFileStorage: {
              uploadedFile: null,
              uploadedFileReader: null,
              downloadedFile: null,
              successfullyUploadedFileId: null,
              hasChanged: null,
            },
            editingFieldsOfMainObject: null,
            relatedMainObject: null,
          },
        ];
    // ci_personnelBankAccounts
    views.ci_personnel[0].ci_personnelBankAccounts = dtos?.ci_personnel[0]?.ci_personnelBankAccounts?.[0]
      ?.id
      ? dtos.ci_personnel[0].ci_personnelBankAccounts?.map((each) => {
          each.tempOtherIndividualIntroductionDocument = {
            uploadedFile: null,
            uploadedFileReader: null,
            downloadedFile: null,
            successfullyUploadedFileId: null,
            hasChanged: null,
          };
          return each;
        })
      : [
          {
            id: null,
            bankAccountNumber: null,
            ibanCode: null,
            isActive: true,
            isDefault: null,
            isForThirdParty: false,
            bankAccountOwnerFullName: null,
            relationWithPersonnel: null,
            otherIndividualIntroductionDocument: null,
            tempOtherIndividualIntroductionDocument: {
              uploadedFile: null,
              uploadedFileReader: null,
              downloadedFile: null,
              successfullyUploadedFileId: null,
              hasChanged: null,
            },
            bankBranch: null,
            editingFieldsOfMainObject: null,
            relatedMainObject: null,
          },
        ];
    // eci_personnelInformationFiles
    views.eci_personnelInformation.eci_personnelInformationFiles = dtos?.eci_personnelInformation
      ?.eci_personnelInformationFiles?.[0]?.id
      ? dtos.eci_personnelInformation.eci_personnelInformationFiles?.map((each, index) => {
          each.tempFileStorage = {
            uploadedFile: null,
            uploadedFileReader: null,
            downloadedFile: null,
            successfullyUploadedFileId: null,
            hasChanged: null,
          };
          return each;
        })
      : [
          {
            id: null,
            personnelFileTypeEnum: null,
            isActive: null,
            eci_personnelInformation: null,
            fileStorage: null,
            editingFieldsOfMainObject: null,
            relatedMainObject: null,
            tempFileStorage: {
              uploadedFile: null,
              uploadedFileReader: null,
              downloadedFile: null,
              successfullyUploadedFileId: null,
              hasChanged: null,
            },
          },
        ];

    views.tempHasNoCompetency = dtos?.eci_personnelInformation?.eci_competencies?.[0]?.id ? false : true;
    views.tempHasNoWorkExp = dtos?.eci_personnelInformation?.eci_workExperiences?.[0]?.id ? false : true;
    views.tempKnowsNoForeignLan = dtos?.eci_personnelInformation?.eci_foreignLanguages?.[0]?.id
      ? false
      : true;
    views.tempNoCoursePassed = dtos?.eci_personnelInformation?.eci_courses?.[0]?.id ? false : true;
    views.tempNotEducatedAtAll = dtos?.eci_personnelInformation?.eci_educationalBackgrounds?.[0]?.id
      ? false
      : true;
    return views;
  };

  const personnelInformationViewToDto = (views) => {
    let dtos = personnelInformationDto;

    // MAIN FIELDSS IN ORDER TO HANDLE THE FIELDS OF JOB APPLY ITSELF STARTS FROM HERE *** BELOW ***
    dtos.id = views.id || null;
    dtos.firstName = views.firstName || null;
    dtos.lastName = views.lastName || null;
    dtos.nationalCode = views.nationalCode || null;
    dtos.cellphone = `+98${views.cellphone?.slice(1)}` || null;
    dtos.workStartDate = views.workStartDate || null;
    dtos.salaryExpectation = views.salaryExpectation || null;
    dtos.readyToStartWorkDate = views.readyToStartWorkDate || null;
    dtos.financialGuaranteeValue = views.financialGuaranteeValue || null;
    dtos.financialGuaranteeTypeEnum = views.financialGuaranteeTypeEnum || null;
    dtos.guarantorName = views.guarantorName || null;
    dtos.preferredTimeZone = views.preferredTimeZone || null;
    dtos.preferredLanguage = views.preferredLanguage || null;
    dtos.preferredCalendar = views.preferredCalendar || null;
    dtos.personnelSalaryDifferenceValue = views.personnelSalaryDifferenceValue || null;
    dtos.personnelSalaryDifferenceToDate = views.personnelSalaryDifferenceToDate || null;
    dtos.hasRelativeOrFriendInOrganization = views.hasRelativeOrFriendInOrganization || null;
    dtos.relativeOrFriendNameInOrganization = views.relativeOrFriendNameInOrganization || null;
    dtos.isReadyForBusinessTrip = views.isReadyForBusinessTrip || null;
    dtos.isWillingToProvideFinancialGuarantee = views.isWillingToProvideFinancialGuarantee || null;
    dtos.companyFamiliarityMethodsEnum = views.companyFamiliarityMethodsEnum || null;
    dtos.companyFamiliarityOtherMethod = views.companyFamiliarityOtherMethod || null;
    dtos.referrerName = views.referrerName || null;
    dtos.stateEnglishName = views.stateEnglishName || null;
    dtos.state = views.state || null;
    dtos.documentSubmissionSchedules = views.documentSubmissionSchedules || null;
    dtos.startWorkSchedules = views.startWorkSchedules || null;
    dtos.businessUnit = views.businessUnit || null;
    dtos.mainOffice = views.mainOffice || null;
    dtos.otherOffices = views.otherOffices || null;
    dtos.mainOrganizationalTitle = views.mainOrganizationalTitle || null;
    dtos.otherInterestedInOrganizationalTitles = views.otherInterestedInOrganizationalTitles || null;
    dtos.corporateChart = views.corporateChart || null;
    dtos.processVersion = views.processVersion || null;
    // MAIN FIELDSS IN ORDER TO HANDLE THE FIELDS OF JOB APPLY ITSELF ENDS HERE *** ABOVE ***
    dtos.eci_personnelInformation.id = views.eci_personnelInformation.id || null;

    dtos.eci_personnelInformation.jobApply = views.eci_personnelInformation.jobApply || null;

    dtos.eci_personnelInformation.editingFieldsOfMainObject =
      views.eci_personnelInformation.editingFieldsOfMainObject || null;
    dtos.eci_personnelInformation.relatedMainObject =
      views.eci_personnelInformation.relatedMainObject || null;
    // MAIN FIELDSS OF CI_PERSON IN ORDER TO HANDLE THE FIELDS OF CI_PERSON ITSELF STARTS FROM HERE *** BELOW ***
    dtos.eci_personnelInformation.eci_person.id = views.eci_personnelInformation.eci_person.id || null;
    dtos.eci_personnelInformation.eci_person.fatherName =
      views.eci_personnelInformation.eci_person.fatherName || null;
    dtos.eci_personnelInformation.eci_person.certifNumber =
      views.eci_personnelInformation.eci_person.certifNumber || null;
    dtos.eci_personnelInformation.eci_person.birthplace =
      views.eci_personnelInformation.eci_person.birthplace || null;
    dtos.eci_personnelInformation.eci_person.certifSerialNumber =
      views.eci_personnelInformation.eci_person.certifSerialNumber || null;
    dtos.eci_personnelInformation.eci_person.certifIssuanceDate =
      views.eci_personnelInformation.eci_person.certifIssuanceDate || null;
    dtos.eci_personnelInformation.eci_person.maritalStatusEnum =
      views.eci_personnelInformation.eci_person.maritalStatusEnum || null;
    dtos.eci_personnelInformation.eci_person.militaryStatusEnum =
      views.eci_personnelInformation.eci_person.militaryStatusEnum || null;
    dtos.eci_personnelInformation.eci_person.healthProblems =
      views.eci_personnelInformation.eci_person.healthProblems || null;
    dtos.eci_personnelInformation.eci_person.hasClassOneDriversLicense =
      views.eci_personnelInformation.eci_person.hasClassOneDriversLicense || null;
    dtos.eci_personnelInformation.eci_person.hasClassTwoDriversLicense =
      views.eci_personnelInformation.eci_person.hasClassTwoDriversLicense || null;
    dtos.eci_personnelInformation.eci_person.hasBikeLicense =
      views.eci_personnelInformation.eci_person.hasBikeLicense || null;
    dtos.eci_personnelInformation.eci_person.birthCertificateIssuingPlace =
      views.eci_personnelInformation.eci_person.birthCertificateIssuingPlace || null;
    dtos.eci_personnelInformation.eci_person.bloodTypeEnum =
      views.eci_personnelInformation.eci_person.bloodTypeEnum || null;
    dtos.eci_personnelInformation.eci_person.nationalCode = views.nationalCode || null;
    dtos.eci_personnelInformation.eci_person.firstName = views.firstName || null;
    dtos.eci_personnelInformation.eci_person.lastName = views.lastName || null;
    dtos.eci_personnelInformation.eci_person.bloodTypeEnum =
      views.eci_personnelInformation.eci_person.bloodTypeEnum || null;
    dtos.eci_personnelInformation.eci_person.birthDate =
      views.eci_personnelInformation.eci_person.birthDate || null;
    dtos.eci_personnelInformation.eci_person.genderEnum =
      views.eci_personnelInformation.eci_person.genderEnum || null;
    // dtos.eci_personnelInformation.eci_person.lifeStatusEnum =
    //   views.eci_personnelInformation.eci_person.lifeStatusEnum || null;
    dtos.eci_personnelInformation.eci_person.cellphone = views.eci_personnelInformation.eci_person
      .cellphone
      ? `+98${views.eci_personnelInformation.eci_person.cellphone?.slice(1)}`
      : null;
    dtos.eci_personnelInformation.eci_person.email =
      views.eci_personnelInformation.eci_person.email || null;
    dtos.eci_personnelInformation.eci_person.nationalityEnum =
      views.eci_personnelInformation.eci_person.nationalityEnum || null;
    dtos.eci_personnelInformation.eci_person.isActive =
      views.eci_personnelInformation.eci_person.isActive;
    dtos.eci_personnelInformation.eci_person.personTags =
      views.eci_personnelInformation.eci_person.personTags?.filter((tag) => tag.id)?.length
        ? views.eci_personnelInformation.eci_person.personTags
        : null;
    dtos.eci_personnelInformation.eci_person.personTitle =
      views.eci_personnelInformation.eci_person.personTitle || null;
    dtos.eci_personnelInformation.eci_person.editingFieldsOfMainObject =
      views.eci_personnelInformation.eci_person.editingFieldsOfMainObject || null;
    dtos.eci_personnelInformation.eci_person.relatedMainObject =
      views.eci_personnelInformation.eci_person.relatedMainObject || null;

    // eci_personContactInfos
    let personContactInfosViews = views.eci_personnelInformation.eci_person.eci_personContactInfos;
    dtos.eci_personnelInformation.eci_person.eci_personContactInfos =
      personContactInfosViews?.length === 0 ? null : personContactInfosViews;
    // eci_personAddresses
    let addressesViews = views.eci_personnelInformation.eci_person.eci_personAddresses;
    dtos.eci_personnelInformation.eci_person.eci_personAddresses =
      addressesViews.length === 0 ? null : addressesViews;
    // eci_educationalBackgrounds
    dtos.eci_personnelInformation.eci_educationalBackgrounds = views.eci_personnelInformation
      .eci_educationalBackgrounds?.length
      ? views.eci_personnelInformation.eci_educationalBackgrounds
      : null;
    // eci_policeClearanceCertificates
    dtos.eci_personnelInformation.eci_policeClearanceCertificates = views.eci_personnelInformation
      .eci_policeClearanceCertificates?.length
      ? views.eci_personnelInformation.eci_policeClearanceCertificates.map((policeCertif) => ({
          id: policeCertif?.id || null,
          policeClearanceCertificateDate: policeCertif?.policeClearanceCertificateDate || null,
          policeClearanceCertificateCode: policeCertif?.policeClearanceCertificateCode || null,
          fileStorage: policeCertif?.fileStorage || null,
          eci_personnelInformation: policeCertif?.eci_personnelInformation || null,
          editingFieldsOfMainObject: policeCertif?.editingFieldsOfMainObject || null,
          relatedMainObject: policeCertif?.relatedMainObject || null,
        }))
      : null;
    // ci_personnelBankAccounts
    dtos.eci_personnelInformation.ci_personnelBankAccounts = views.eci_personnelInformation
      .ci_personnelBankAccounts?.length
      ? views.eci_personnelInformation.ci_personnelBankAccounts.map((bankAcc) => ({
          id: bankAcc?.id || null,
          bankAccountNumber: bankAcc?.bankAccountNumber || null,
          ibanCode: bankAcc?.ibanCode || null,
          isActive: bankAcc?.isActive,
          isDefault: bankAcc?.isDefault || null,
          isForThirdParty: bankAcc?.isForThirdParty,
          bankAccountOwnerFullName: bankAcc?.bankAccountOwnerFullName || null,
          relationWithPersonnel: bankAcc?.relationWithPersonnel || null,
          otherIndividualIntroductionDocument: bankAcc?.otherIndividualIntroductionDocument || null,
          bankBranch: bankAcc?.bankBranch,
          eci_personnelInformation: bankAcc?.eci_personnelInformation,
          editingFieldsOfMainObject: bankAcc?.editingFieldsOfMainObject || null,
          relatedMainObject: bankAcc?.relatedMainObject || null,
        }))
      : null;
    // eci_personnelInformationFiles
    dtos.eci_personnelInformation.eci_personnelInformationFiles = views.eci_personnelInformation
      ?.eci_personnelInformationFiles?.length
      ? views.eci_personnelInformation.eci_personnelInformationFiles.map((perInfFile) => ({
          id: perInfFile?.id || null,
          personnelFileTypeEnum: perInfFile?.personnelFileTypeEnum || null,
          isActive: perInfFile?.isActive,
          eci_personnelInformation: perInfFile?.eci_personnelInformation || null,
          fileStorage: perInfFile?.fileStorage || null,
          editingFieldsOfMainObject: perInfFile?.editingFieldsOfMainObject || null,
          relatedMainObject: perInfFile?.relatedMainObject || null,
        }))
      : null;
    // eci_recommenders
    dtos.eci_personnelInformation.eci_recommenders = views.eci_personnelInformation.eci_recommenders
      ?.length
      ? views.eci_personnelInformation.eci_recommenders.map((recommender) => ({
          id: recommender?.id || null,
          fullName: recommender?.fullName || null,
          age: recommender?.age || null,
          cellphone: `+98${recommender?.cellphone?.slice(1)}` || null,
          job: recommender?.job || null,
          workplace: recommender?.workplace || null,
          relation: recommender?.relation || null,
          editingFieldsOfMainObject: recommender?.editingFieldsOfMainObject || null,
          relatedMainObject: recommender?.relatedMainObject || null,
        }))
      : null;
    // eci_familyMembers
    dtos.eci_personnelInformation.eci_familyMembers = views.eci_personnelInformation.eci_familyMembers
      ?.length
      ? views.eci_personnelInformation.eci_familyMembers.map((fmMember) => ({
          id: fmMember?.id || null,
          fullName: fmMember?.fullName || null,
          familyRelationEnum: fmMember?.familyRelationEnum || null,
          age: fmMember?.age || null,
          job: fmMember?.job || null,
          cellphone: `+98${fmMember?.cellphone?.slice(1)}` || null,
          workplace: fmMember?.workplace || null,
          isDead: fmMember?.isDead,
          editingFieldsOfMainObject: fmMember?.editingFieldsOfMainObject || null,
          relatedMainObject: fmMember?.relatedMainObject || null,
        }))
      : null;
    // eci_foreignLanguages
    dtos.eci_personnelInformation.eci_foreignLanguages = views.eci_personnelInformation
      .eci_foreignLanguages?.length
      ? views.eci_personnelInformation.eci_foreignLanguages.map((fmMember) => ({
          id: fmMember?.id || null,
          languageName: fmMember?.languageName || null,
          listening: fmMember?.listening || null,
          writing: fmMember?.writing || null,
          reading: fmMember?.reading || null,
          speaking: fmMember?.speaking || null,
        }))
      : null;
    // eci_workExperiences
    dtos.eci_personnelInformation.eci_workExperiences = views.eci_personnelInformation
      .eci_workExperiences?.length
      ? views.eci_personnelInformation.eci_workExperiences.map((workExperience) => ({
          id: workExperience?.id || null,
          employer: workExperience?.employer || null,
          post: workExperience?.post || null,
          directManagerName: workExperience?.directManagerName || null,
          directManagerCellphone: workExperience?.directManagerCellphone
            ? `+98${workExperience?.directManagerCellphone?.slice(1)}`
            : null,
          salary: workExperience?.salary || null,
          resigningReason: workExperience?.resigningReason || null,
          startDate: workExperience?.startDate,
          finishDate: workExperience?.finishDate,
          editingFieldsOfMainObject: workExperience?.editingFieldsOfMainObject || null,
          relatedMainObject: workExperience?.relatedMainObject || null,
        }))
      : null;
    // eci_competencies
    dtos.eci_personnelInformation.eci_competencies = views.eci_personnelInformation.eci_competencies
      ?.length
      ? views.eci_personnelInformation.eci_competencies.map((fmMember) => ({
          id: fmMember?.id || null,
          levelOfProficiency: fmMember?.levelOfProficiency || null,
          competencyName: fmMember?.competencyName || null,
        }))
      : null;
    // eci_courses
    dtos.eci_personnelInformation.eci_courses = views.eci_personnelInformation.eci_courses?.length
      ? views.eci_personnelInformation.eci_courses
      : null;
    // ci_personnel
    dtos.ci_personnel = views.ci_personnel?.length
      ? [
          {
            id: views.ci_personnel[0].id || null,
            personnelCode: views.ci_personnel[0].personnelCode || null,
            internalPhoneNumber: views.ci_personnel[0].internalPhoneNumber || null,
            insuranceCode: views.ci_personnel[0].insuranceCode || null,
            eci_personnelInformation: views.ci_personnel[0],
            insuranceDate: views.ci_personnel[0].insuranceDate || null,
            // financialGuaranteeValue: views.ci_personnel[0].financialGuaranteeValue || null,
            // financialGuaranteeTypeEnum: views.ci_personnel[0].financialGuaranteeTypeEnum || null,
            // guarantorName: views.ci_personnel[0].guarantorName || null,
            ci_personnelFiles: views.ci_personnel[0].ci_personnelFiles || null,
            ci_personnelContracts: views.ci_personnel[0].ci_personnelContracts || null,
            editingFieldsOfMainObject: views.ci_personnel[0].editingFieldsOfMainObject || null,
            relatedMainObject: views.ci_personnel[0].relatedMainObject || null,
            isActive: views.ci_personnel[0].isActive,
          },
        ]
      : null;

    return dtos;
  };
  const personnelInformationFormSupportDtoToFormValidity = (dtos) => {
    let viewsFormValidity = personnelInformationFromValidity;
    console.log("dtos", dtos);
    if (Array.isArray(dtos?.eci_personnelInformation?.eci_educationalBackgrounds))
      viewsFormValidity.eci_personnelInformation.eci_educationalBackgrounds =
        dtos.eci_personnelInformation.eci_educationalBackgrounds.map((each) => ({
          startDate: { isValid: true, msg: "" },
          finishDate: { isValid: true, msg: "" },
          thesisAim: { isValid: true, msg: "" },
          favoriteUnits: { isValid: true, msg: "" },
          gradePointAverage: { isValid: true, msg: "" },
          otherInstitute: { isValid: true, msg: "" },
          degreeLevelEnum: { isValid: true, msg: "" },
          academicOrientation: { isValid: true, msg: "" },
          major: { isValid: true, msg: "" },
          educationalInstitute: { isValid: true, msg: "" },
          editingFieldsOfMainObject: { isValid: true, msg: "" },
          relatedMainObject: { isValid: true, msg: "" },
          currentlyStudying: { isValid: true, msg: "" },
          faculty: { isValid: true, msg: "" },
        }));
    if (Array.isArray(dtos?.eci_personnelInformation?.eci_recommenders))
      viewsFormValidity.eci_personnelInformation.eci_recommenders =
        dtos.eci_personnelInformation.eci_recommenders.map((each) => ({
          fullName: { isValid: true, msg: "" },
          age: { isValid: true, msg: "" },
          cellphone: { isValid: true, msg: "" },
          job: { isValid: true, msg: "" },
          workplace: { isValid: true, msg: "" },
          relation: { isValid: true, msg: "" },
          editingFieldsOfMainObject: { isValid: true, msg: "" },
          relatedMainObject: { isValid: true, msg: "" },
        }));

    if (Array.isArray(dtos?.eci_personnelInformation?.eci_competencies))
      viewsFormValidity.eci_personnelInformation.eci_competencies =
        dtos.eci_personnelInformation.eci_competencies.map((each) => ({
          levelOfProficiency: { isValid: true, msg: "" },
          competencyName: { isValid: true, msg: "" },
        }));

    if (Array.isArray(dtos?.eci_personnelInformation?.eci_foreignLanguages))
      viewsFormValidity.eci_personnelInformation.eci_foreignLanguages =
        dtos.eci_personnelInformation.eci_foreignLanguages.map((each) => ({
          languageName: { isValid: true, msg: "" },
          listening: { isValid: true, msg: "" },
          writing: { isValid: true, msg: "" },
          reading: { isValid: true, msg: "" },
          speaking: { isValid: true, msg: "" },
        }));
    if (Array.isArray(dtos?.eci_personnelInformation?.eci_personnelInformationFiles))
      viewsFormValidity.eci_personnelInformation.eci_personnelInformationFiles =
        dtos.eci_personnelInformation.eci_personnelInformationFiles.map((each) => ({
          personnelFileTypeEnum: { isValid: true, msg: "" },
          isActive: { isValid: true, msg: "" },
          eci_personnelInformation: { isValid: true, msg: "" },
          fileStorage: { isValid: true, msg: "" },
          editingFieldsOfMainObject: { isValid: true, msg: "" },
          relatedMainObject: { isValid: true, msg: "" },
        }));
    if (Array.isArray(dtos?.eci_personnelInformation?.eci_courses))
      viewsFormValidity.eci_personnelInformation.eci_courses =
        dtos.eci_personnelInformation.eci_courses.map((each) => ({
          title: { isValid: true, msg: "" },
          startDate: { isValid: true, msg: "" },
          duration: { isValid: true, msg: "" },
          hasDiploma: { isValid: true, msg: "" },
          otherInstitute: { isValid: true, msg: "" },
          educationalInstitute: { isValid: true, msg: "" },
          editingFieldsOfMainObject: { isValid: true, msg: "" },
          relatedMainObject: { isValid: true, msg: "" },
        }));
    if (Array.isArray(dtos?.eci_personnelInformation?.eci_familyMembers))
      viewsFormValidity.eci_personnelInformation.eci_familyMembers =
        dtos.eci_personnelInformation.eci_familyMembers.map((each) => ({
          fullName: { isValid: true, msg: "" },
          familyRelationEnum: { isValid: true, msg: "" },
          age: { isValid: true, msg: "" },
          job: { isValid: true, msg: "" },
          cellphone: { isValid: true, msg: "" },
          workplace: { isValid: true, msg: "" },
          isDead: { isValid: true, msg: "" },
          editingFieldsOfMainObject: { isValid: true, msg: "" },
          relatedMainObject: { isValid: true, msg: "" },
        }));
    if (Array.isArray(dtos?.eci_personnelInformation?.eci_workExperiences))
      viewsFormValidity.eci_personnelInformation.eci_workExperiences =
        dtos.eci_personnelInformation.eci_workExperiences.map((each) => ({
          employer: { isValid: true, msg: "" },
          post: { isValid: true, msg: "" },
          directManagerName: { isValid: true, msg: "" },
          directManagerCellphone: { isValid: true, msg: "" },
          salary: { isValid: true, msg: "" },
          resigningReason: { isValid: true, msg: "" },
          startDate: { isValid: true, msg: "" },
          finishDate: { isValid: true, msg: "" },
          editingFieldsOfMainObject: { isValid: true, msg: "" },
          relatedMainObject: { isValid: true, msg: "" },
        }));
    if (Array.isArray(dtos?.eci_personnelInformation?.eci_policeClearanceCertificates))
      viewsFormValidity.eci_personnelInformation.eci_policeClearanceCertificates =
        dtos.eci_personnelInformation.eci_policeClearanceCertificates.map((each) => ({
          policeClearanceCertificateDate: { isValid: true, msg: "" },
          policeClearanceCertificateCode: { isValid: true, msg: "" },
          fileStorage: { isValid: true, msg: "" },
          editingFieldsOfMainObject: { isValid: true, msg: "" },
          relatedMainObject: { isValid: true, msg: "" },
        }));
    if (Array.isArray(dtos?.ci_personnel[0]?.ci_personnelBankAccounts))
      viewsFormValidity.ci_personnel[0].ci_personnelBankAccounts =
        dtos.ci_personnel[0].ci_personnelBankAccounts.map((each) => ({
          bankAccountNumber: { isValid: true, msg: "" },
          ibanCode: { isValid: true, msg: "" },
          isActive: { isValid: true, msg: "" },
          isDefault: { isValid: true, msg: "" },
          isForThirdParty: { isValid: true, msg: "" },
          bankAccountOwnerFullName: { isValid: true, msg: "" },
          relationWithPersonnel: { isValid: true, msg: "" },
          otherIndividualIntroductionDocument: { isValid: true, msg: "" },
          bankBranch: { isValid: true, msg: "" },
          editingFieldsOfMainObject: { isValid: true, msg: "" },
          relatedMainObject: { isValid: true, msg: "" },
        }));
    return viewsFormValidity;
  }; // THIS NEEDS TO BE COMPLETED ** IT IS ESSENSIAL

  function cleanObject(obj) {
    const isObjectEmpty = (innerObj) =>
      Object.values(innerObj).every(
        (value) => value === null || (Array.isArray(value) && value.every((item) => isObjectEmpty(item)))
      );

    if (Array.isArray(obj.ci_personnelBankAccounts)) {
      const allNestedEmpty = obj.ci_personnelBankAccounts.every((item) => isObjectEmpty(item));
      if (allNestedEmpty) {
        obj.ci_personnelBankAccounts = null;
      }
    }

    return isObjectEmpty(obj) ? null : [obj];
  }

  const filterEmptyArras = (views) => {
    const clonedViews = JSON.parse(JSON.stringify(views));
    const newViews = {
      ...clonedViews,
      ci_personnel: cleanObject(...clonedViews.ci_personnel),

      eci_personnelInformation: {
        ...clonedViews.eci_personnelInformation,
        eci_competencies: filterArrayObObjsByKeys(
          clonedViews.eci_personnelInformation.eci_competencies,
          ["competencyName", "id", "levelOfProficiency"]
        ),
        eci_foreignLanguages: filterArrayObObjsByKeys(
          clonedViews.eci_personnelInformation.eci_foreignLanguages,
          ["writing", "id", "listening", "speaking", "reading", "languageName"]
        ),
        eci_person: {
          ...clonedViews.eci_personnelInformation.eci_person,
          eci_personContactInfos: filterArrayObObjsByKeys(
            clonedViews.eci_personnelInformation.eci_person.eci_personContactInfos,
            ["contactInfoTypeEnum", "id", "value"]
          ),
          eci_personAddresses: filterPersonAddresses(
            clonedViews.eci_personnelInformation.eci_person.eci_personAddresses
          ),
        },

        eci_educationalBackgrounds: filterArrayObObjsByKeys(
          clonedViews.eci_personnelInformation.eci_educationalBackgrounds,
          [
            "id",
            "startDate",
            "finishDate",
            "thesisAim",
            "favoriteUnits",
            "gradePointAverage",
            "otherInstitute",
            "degreeLevelEnum",
            "academicOrientation.id",
            "major.id",
            "educationalInstitute.id",
            "currentlyStudying",
            "faculty.id",
          ]
        ),
        eci_recommenders: filterArrayObObjsByKeys(
          clonedViews.eci_personnelInformation.eci_recommenders,
          ["id", "fullName", "age", "cellphone", "job", "workplace", "relation"]
        ),
        eci_personnelInformationFiles: filterArrayObObjsByKeys(
          clonedViews.eci_personnelInformation.eci_personnelInformationFiles,
          ["id", "personnelFileTypeEnum", "fileStorage.id"]
        ),
        eci_courses: filterArrayObObjsByKeys(clonedViews.eci_personnelInformation.eci_courses, [
          "id",
          "title",
          "startDate",
          "duration",
          "hasDiploma",
          "otherInstitute",
          "educationalInstitute.id",
        ]),
        eci_familyMembers: filterArrayObObjsByKeys(
          clonedViews.eci_personnelInformation.eci_familyMembers,
          ["id", "fullName", "familyRelationEnum", "age", "job", "cellphone", "workplace", "isDead"]
        ),
        eci_workExperiences: filterArrayObObjsByKeys(
          clonedViews.eci_personnelInformation.eci_workExperiences,
          [
            "id",
            "employer",
            "post",
            "directManagerName",
            "directManagerCellphone",
            "salary",
            "resigningReason",
            "startDate",
            "finishDate",
          ]
        ),
        eci_policeClearanceCertificates: filterArrayObObjsByKeys(
          clonedViews.eci_personnelInformation.eci_policeClearanceCertificates,
          ["id", "policeClearanceCertificateDate", "policeClearanceCertificateCode", "fileStorage.id"]
        ),
        // ci_personnelBankAccounts: filterArrayObObjsByKeys(
        //   clonedViews.ci_personnel.ci_personnelBankAccounts,
        //   [
        //     "id",
        //     "bankAccountNumber",
        //     "ibanCode",
        //     "bankAccountOwnerFullName",
        //     "relationWithPersonnel",
        //     "otherIndividualIntroductionDocument",
        //     "bankBranch",
        //   ]
        // ),
      },
    };
    return newViews;
  };
  return [
    personnelInformationDto,
    personnelInformationView,
    personnelInformationDtoToView,
    personnelInformationViewToDto,
    personnelInformationFormSupportDtoToFormValidity,
    fieldNameAddresses,
    personnelInformationFromValidity,
    filterEmptyArras,
  ];
};

export default PersonnelInformationFormSupport;
